import React, { useState, useEffect } from 'react';
import { Box, Container, CssBaseline, Fab, Zoom, useScrollTrigger, Fade } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Header from './Header';
import Footer from './Footer';
import LoadingScreen from './LoadingScreen';

const ScrollTop = ({ children }) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Zoom in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 1000,
        }}
      >
        {children}
      </Box>
    </Zoom>
  );
};

const Layout = ({ children }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: 'background.default',
        position: 'relative',
      }}
    >
      <CssBaseline />

      {/* Loading Screen */}
      <LoadingScreen loading={loading} />

      {/* Main Content */}
      {!loading && (
        <Fade in={!loading} timeout={800}>
          <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Header />
            <Container
              component="main"
              sx={{
                mt: { xs: 2, md: 4 },
                mb: { xs: 2, md: 4 },
                flex: 1,
                position: 'relative',
                zIndex: 1,
              }}
              maxWidth="xl"
            >
              {children}
            </Container>
            <Footer />

            {/* Scroll to top button */}
            <ScrollTop>
              <Fab
                color="primary"
                size="small"
                aria-label="scroll back to top"
                sx={{
                  boxShadow: 4,
                  '&:hover': {
                    transform: 'scale(1.1)',
                    boxShadow: 6,
                  },
                  transition: 'all 0.3s ease',
                }}
              >
                <KeyboardArrowUpIcon />
              </Fab>
            </ScrollTop>
          </Box>
        </Fade>
      )}
    </Box>
  );
};

export default Layout;
